import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { FiEdit, FiCheck, FiX } from "react-icons/fi";

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

interface Subscription {
  subscription_id: number;
  subscription_name: string;
  start_date: string;
  end_date: string | null;
  is_active: boolean;
  role_limits:RoleLimits;
}

interface RoleLimits {
    admin_user_count: number;
    tutor_user_count: number;
    student_user_count: number;
  }

interface TenantUsersCount{
  tenant_id: number;
  total_admins : number;
  total_tutors : number;
  total_students : number;
  active_admins : number;
  active_tutors: number;
  active_students : number;
}

interface AdminUser{
    user_id : number;
    username : string;
    email : string;
    password : string;
    tenant_id : number;
    role_id:number;
    is_active : boolean;
}


const AdminCreator: React.FC = () => {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const [subscription, setSubscription] = useState<Subscription>();
  const [tenantUsersCount, setTenantUsersCount] = useState<TenantUsersCount>();

  const [adminUsers, setAdminUsers] = useState<AdminUser[]>([]);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [editRow, setEditRow] = useState<number | null>(null); // Track the row currently being edited
  const [newAdmin, setNewAdmin] = useState<AdminUser | null>(null);

  const { isOpen, onOpen, onClose } = useDisclosure();

  // Second modal disclosure for removing an item from the subscription queue
  const { isOpen: isRemoveModalOpen, onOpen: onRemoveModalOpen, onClose: onRemoveModalClose } = useDisclosure();

  // New disclosure for the collapsible panel
  const { isOpen: isPanelOpen, onToggle } = useDisclosure(); // For the collapsible panel


  const toast = useToast();

  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
        const response = await axios.get(tenantsapiurl, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        const filteredTenants = response.data.filter((tenant: Tenant) => tenant.tenant_id !== 1);
        setTenants(filteredTenants);
        if (filteredTenants.length > 0) {
          setSelectedTenant(filteredTenants[0].tenant_id);
        }
      } catch (error) {
        console.error("Failed to load tenants", error);
      }
    };
    fetchTenants();
  }, []);

  useEffect(() => {
    if (selectedTenant) {
      const fetchSubscription = async () => {
        try {
          const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
          const response = await axios.get(tenantsapiurl + `/${selectedTenant}/active-subscription`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
          setSubscription(response.data);
        } catch (error) {
          console.error("Failed to load Subscription", error);
        }
      };
      fetchSubscription();

      const fetchTenantUsersCount = async () => {
        try {
          const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
          const response = await axios.get(tenantsapiurl + `/${selectedTenant}/user-roles`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
          setTenantUsersCount(response.data);
        } catch (error) {
          console.error("Failed to load Tenants Users Count by Roles", error);
        }
      };
      fetchTenantUsersCount();

      fetchAdminUsers();
    }
  }, [selectedTenant]);

  const fetchAdminUsers = async () => {
    try {
        const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
        const response = await axios.get(tenantsapiurl + `/${selectedTenant}/admin-users`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setAdminUsers(response.data);
    } catch (error) {
      console.error("Failed to load admin users", error);
    }
  };

  const handleAddNewAdmin = () => {
    setIsAddingNew(true);
    setNewAdmin({ tenant_id:0, user_id: 0, username: '', email: '',password:'', role_id:0, is_active: true });
  };

  const handleRemoveNewAdmin = () => {
    setIsAddingNew(false);
    setNewAdmin(null);
  };

  const handleSaveAdmin = async (adminuser: AdminUser) => {
    try {
        
        if (selectedTenant) {
        adminuser.tenant_id = selectedTenant
        }
        adminuser.role_id=2;

        const payload = {
            username: adminuser.username,
            email: adminuser.email,
            password: adminuser.password,
            tenant_id: selectedTenant || adminuser.tenant_id,
            role_id: 2,
            is_active: adminuser.is_active,
        };
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      
      console.log("printing admin user payload",payload);

      const response = await axios.post(apiurl+`/CreateUser/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setAdminUsers([...adminUsers, response.data]);
      setIsAddingNew(false);
      setNewAdmin(null);
      toast({ title: "Admin User added successfully", status: "success" });
    } catch (error) {
      console.error("Failed to save Admin User", error);
      toast({ title: "Failed to add Admin User", status: "error" });
    }
  };

  const handleUpdateAdmin = async (adminuser: AdminUser) => {

    try {
        if (selectedTenant) {
            adminuser.tenant_id = selectedTenant
            }
            adminuser.role_id=2;
    
            const payload = {
                username: adminuser.username,
                email: adminuser.email,
                password: adminuser.password,
                tenant_id: selectedTenant || adminuser.tenant_id,
                role_id: 2,
                is_active: adminuser.is_active,
            };
          const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
          
          console.log("printing admin user payload",payload);

          console.log("printing admin user id",adminuser.user_id);
     
      console.log("Printing Token from Update" + localStorage.getItem("token"));
      await axios.put(apiurl+`/update-user/${adminuser.user_id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      fetchAdminUsers();
      setEditRow(null); // Reset edit mode after successful update
      toast({ title: "Tenant updated successfully", status: "success" });
    } catch (error) {
      console.error("Failed to update tenant", error);
      toast({ title: "Failed to update tenant", status: "error" });
    }
  };

  const handleEditRow = (user_id: number) => {
    setEditRow(user_id);
    setIsAddingNew(false); // Disable add tenant while editing
  };

  const handleCancelEdit = () => {
    setEditRow(null);
    setIsAddingNew(false);
  };


  // Typing the setter function and the event handler parameter
  const handleNumberInputChange = (
    setter: React.Dispatch<React.SetStateAction<string>>
  ) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    // Only set if value is not negative and is a number
    if (!isNaN(value) && value >= 0) {
      setter(value.toString());
    } else if (e.target.value === '') {
      setter(''); // Allow clearing the input
    }
  };
  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>Admin Accounts Manager</Heading>
      </VStack>

      <Box  borderColor={"gray.300"} mt = {4} borderWidth={1} borderRadius="sm" mb={4}>
        {/* Tenant selection */}
        <HStack mt={4} mb={4} ml={2} mr={2}>
        <Text fontSize="sm" minWidth={"120px"}>Select Tenant:</Text>
        <Select borderRadius="sm"
          placeholder="Select Tenant"
          size="sm" fontSize="sm"
          value={selectedTenant || ''}
          onChange={(e) => setSelectedTenant(parseInt(e.target.value))}
        >
          {tenants.map((tenant) => (
            <option key={tenant.tenant_id} value={tenant.tenant_id}>
              {tenant.name}
            </option>
          ))}
        </Select>
        </HStack>
        </Box>
  
        <Box p={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm" mb={4}>
                <Text fontSize="lg" fontWeight="bold" mb={2}>
                   Active Subscription Details for the Tenant
                </Text>
                {subscription? (
                    <Table variant="simple" size="sm">
                        <Tbody>
                            <Tr>
                                <Td fontWeight="bold">Subscription Name:</Td>
                                <Td>{subscription.subscription_name}</Td>
                            </Tr>
                            <Tr>
                                <Td fontWeight="bold">Subscription Start Date:</Td>
                                <Td>{subscription.start_date ? new Date(subscription.start_date).toLocaleDateString() : "N/A"}</Td>
                            </Tr>
                            <Tr>
                                <Td fontWeight="bold">Subscription End Date:</Td>
                                <Td>{subscription.end_date ? new Date(subscription.end_date).toLocaleDateString() : "N/A"}</Td>
                            </Tr>
                            <Tr>
                                <Td fontWeight="bold">Subscription Status</Td>
                                <Td>{subscription.is_active ? 'Active' : 'Inactive'}</Td>
                            </Tr>
                            <Tr>
                                <Td fontWeight="bold">Subscribed Admin User Count</Td>
                                <Td>{subscription.role_limits.admin_user_count}</Td>
                            </Tr>
                            <Tr>
                                <Td fontWeight="bold">Subscribed Tutor User Count</Td>
                                <Td> {subscription.role_limits.tutor_user_count}</Td>
                            </Tr>
                            <Tr>
                                <Td fontWeight="bold">Subscribed Student User Count</Td>
                                <Td>{subscription.role_limits.student_user_count}</Td>
                            </Tr>
                        </Tbody>
                    </Table>
                ) : (
                    <Text>Loading metadata...</Text>
                )}
          </Box>

          <Box p={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm" mb={4}>
                <Text fontSize="lg" fontWeight="bold" mb={2}>
                Users Count By Roles for the Tenant
                </Text>
                {tenantUsersCount? (
                    <Table variant="simple" size="sm">
                        <Tbody>
                            <Tr>
                                <Td fontWeight="bold">User Type</Td>
                                <Td fontWeight="bold">Total Created Users </Td>
                                <Td fontWeight="bold">Active Users</Td>
                            </Tr>
                            <Tr>
                                <Td >Admin</Td>
                                <Td>{tenantUsersCount?.total_admins}</Td>
                                <Td>{tenantUsersCount?.active_admins}</Td>
                            </Tr>
                            <Tr>
                                <Td >Tutor</Td>
                                <Td>{tenantUsersCount?.total_tutors}</Td>
                                <Td>{tenantUsersCount?.active_tutors}</Td>
                            </Tr>
                            <Tr>
                                <Td >Student</Td>
                                <Td>{tenantUsersCount?.total_students}</Td>
                                <Td>{tenantUsersCount?.active_students}</Td>
                            </Tr>
                           
                        </Tbody>
                    </Table>
                ) : (
                    <Text>Loading metadata...</Text>
                )}
          </Box>

      <Box mt={4}>
      {/* Collapsible button to toggle the form */}
      <Button
        borderRadius={"sm"} fontSize="sm" fontWeight="normal"
        onClick={onToggle} // Toggle the collapsible panel visibility
        aria-expanded={isPanelOpen}
        aria-controls="subscription-form-panel"
      >
        {isPanelOpen ? '- Create or Update Admins' : '+ Create or Update Admins'}
      </Button>
      
      
        <Box p={2}  borderWidth={"thin"} borderStyle={'dashed'} borderColor={"blackAlpha.400"}>
      {/* Collapsible panel with the form */}
      <Collapse in={isPanelOpen} >
      <Box mt={4} ml={2}>
      <Text fontWeight="bold">Admin User Details</Text>
              <Button mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewAdmin} isDisabled={isAddingNew || editRow !== null}>
          + Admin User
        </Button>
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead>
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Username</Th>
              <Th>Email</Th>
              <Th>Password</Th>
              <Th>Active</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="sm">
          {isAddingNew && newAdmin && (
              <Tr
              fontSize="sm" // Control font size inside input 
              >
                <Td>New</Td>
                <Td>
                  <Input
                    size="sm" // Control the input size here
                    fontSize="sm" // Control font size inside input
                    value={newAdmin.username}
                    onChange={(e) => setNewAdmin({ ...newAdmin, username: e.target.value })}
                  />
                </Td>

                <Td>
                  <Input
                    size="sm" // Control the input size here
                    fontSize="sm" // Control font size inside input
                    value={newAdmin.email}
                    onChange={(e) => setNewAdmin({ ...newAdmin, email: e.target.value })}
                  />
                </Td>

                <Td>
                  <Input
                    size="sm" // Control the input size here
                    fontSize="sm" // Control font size inside input
                    value={newAdmin.password}
                    onChange={(e) => setNewAdmin({ ...newAdmin, password: e.target.value })}
                  />
                </Td>
    
                <Td>
                  <Checkbox
                 
                    isChecked={newAdmin.is_active}
                    onChange={(e) => setNewAdmin({ ...newAdmin, is_active: e.target.checked })}
                  />
                </Td>
                <Td>
                  <Tooltip label="Save">
                    <Button size="sm" onClick={() => handleSaveAdmin(newAdmin)}><FiCheck /></Button>
                  </Tooltip>
                  <Tooltip label="Cancel">
                    <Button size="sm" ml={2} onClick={handleRemoveNewAdmin}><FiX /></Button>
                  </Tooltip>
                </Td>
              </Tr>
            )}
            {adminUsers.map((adminUser) => (
              <Tr key={adminUser.user_id} opacity={editRow && editRow !== adminUser.user_id ? 0.5 : isAddingNew ? 0.5 : 1}>
                <Td>{adminUser.user_id}</Td>
                <Td>
                  {editRow === adminUser.user_id ? (
                    <Input
                      size="sm" // Control the input size here
                      fontSize="sm" // Control font size inside input
                      value={adminUser.username}
                      onChange={(e) => {
                        adminUser.username = e.target.value;
                        setAdminUsers([...adminUsers]);
                      }}
                    />
                  ) : (
                    adminUser.username
                  )}
                </Td>
                <Td>
                  {editRow === adminUser.user_id ? (
                    <Input
                    size="sm" // Control the input size here
                      fontSize="sm" // Control font size inside input
                      value={adminUser.email}
                      onChange={(e) => {
                        adminUser.email = e.target.value;
                        setAdminUsers([...adminUsers]);
                      }}
                    />
                  ) : (
                    adminUser.email
                  )}
                </Td>
                <Td>
                  {editRow === adminUser.user_id ? (
                    <Input
                    size="sm" // Control the input size here
                      fontSize="sm" // Control font size inside input
                      placeholder="Enter to Reset Password"
                      value={adminUser.password}
                      onChange={(e) => {
                        adminUser.password = e.target.value;
                        setAdminUsers([...adminUsers]);
                      }}
                    />
                  ) : (
                    adminUser.password
                  )}
                </Td>
                <Td>
                  {editRow === adminUser.user_id ? (
                    <Checkbox
       
                      isChecked={adminUser.is_active}
                      onChange={(e) => {
                        adminUser.is_active = e.target.checked;
                        setAdminUsers([...adminUsers]);
                      }}
                    />
                  ) : adminUser.is_active ? "Active" : "Inactive"}
                </Td>
                <Td>
                  { editRow === adminUser.user_id ? (
                    <HStack>
                      <Tooltip label="Update">
                        <Button size="sm" onClick={() => handleUpdateAdmin(adminUser)}><FiCheck /></Button>
                      </Tooltip>
                      <Tooltip label="Cancel">
                        <Button size="sm" ml={2} onClick={handleCancelEdit}><FiX /></Button>
                      </Tooltip>
                      </HStack>
                  ) : (
                    <Tooltip label="Edit">
                      <Button size="sm" onClick={() => handleEditRow(adminUser.user_id)}><FiEdit /></Button>
                    </Tooltip>
                  )}
                </Td>
              </Tr>
            ))}

          </Tbody>
        </Table>
      </Box>

        </Collapse>
        </Box>
        </Box>
    </Box>
  );
};

export default AdminCreator;
